import {render} from 'react-renderer';

export let escape = (function () {
    var MAP = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&#34;',
        "'": '&#39;'
    };

    var repl = function (c) {
        return MAP[c];
    };

    return function (s) {
        return s.replace(/[&<>'"]/g, repl);
    };
})();

export function reactElementToString(element) {
    if (typeof document.createElement != 'function') {
        let ReactDOMServer = require('react-dom/server');
        return ReactDOMServer.renderToString(element);
    }

    return render(element);
}



// WEBPACK FOOTER //
// ./src/l10n/utils.js